export default __webpack_public_path__ + "static/media/ig_btn.1bedd94e.webp";